import { apiHost } from '../../../config';
import { put } from '../../requests';
import City from '../../../types/City';

export default async function updateCity(
  id: number,
  city: Partial<Omit<City, 'id'>>,
) {
  return put(`${apiHost}/api/admin/cities/${id}`, city);
}
